import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import ProjectsHeader from '../components/rts/Projects/ProjectsHeader';
import ProjectsFilter from '../components/rts/Projects/ProjectsFilter';
import ProjectsList from '../components/rts/Projects/ProjectsList';

import { useSessionContext } from '../contexts/SessionContext';

export default function ProjectsPage( props ){
    //console.debug("RTS Break ProjectsPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Projects/GetProjectsSummary";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]); 


    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'ProjectsPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({user:user, customer:sessionCustomer.customer, manager:null, status:-1, sortBy:0});
            fetchData({user:user, customer:sessionCustomer.customer, manager:null, status:-1, sortBy:0})
        }
    }, [props, user, sessionCustomer, curFilter, fetchData]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };


    return(
        <Box>
            <ProjectsHeader />
            <ProjectsFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <ProjectsList data={data} />
            </Box>
        </Box>
    );

}

